<template>
  <div class="su-grid" :style="_style">
    <slot :cols="cols"></slot>
  </div>
</template>
<script>
import GridItem from './GridItem'
export default {
  name: 'Grid',
  item: GridItem,
  componentName: 'grid',
  props: {
    cols: {
      type: Number,
      default: 2
    },
    type: {
      type: String,
      default: 'grid'
    },
    rowMargin: {
      type: String,
      default: '0px'
    },
    colMargin: {
      type: String,
      default: '0px'
    },
    _style: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      childLength: 0
    }
  },
  computed: {
    getFlexDirection() {
      return this.type === 'grid' ? 'row' : 'column'
    },
    getFlexWrap() {
      return this.type === 'grid' ? 'wrap' : 'nowrap'
    }
  },
  //  向后代组件注入数据
  provide() {
    return {
      grid: this
    }
  },
  created() {
    this.$on('childAdd', () => (this.childLength += 1))
    this.$on('childRm', () => (this.childLength -= 1))
  },
  mounted() {}
}
</script>
<style lang="scss">
.su-grid {
  display: flex;
  flex-flow: row wrap;
}
</style>
